import React from 'react';
import PropTypes from 'prop-types';
import SinglePicker from '../../common/controls/singlePicker';
const openClosedFilterOptions = [{
  value: '0',
  id: '0',
  label: 'Open',
  className: 't-es-option-open',
  name: 'Open'
}, {
  value: '1',
  id: '1',
  label: 'Closed',
  className: 't-es-option-closed',
  name: 'Closed'
}];
const OpenClosedFilter = _ref => {
  let onFilter = _ref.onFilter,
    closed = _ref.closed;
  return /*#__PURE__*/React.createElement(SinglePicker, {
    className: "t-jc-open-closed",
    clearable: false,
    label: "Open/Closed",
    onChange: _ref2 => {
      let value = _ref2.value;
      return onFilter('closed', value);
    },
    options: openClosedFilterOptions,
    searchable: false,
    value: closed
  });
};
OpenClosedFilter.propTypes = {
  closed: PropTypes.string.isRequired,
  onFilter: PropTypes.func.isRequired
};
export default OpenClosedFilter;